<template>
  <v-container fluid>

    <div class="d-flex align-center pb-3">
      <div>
        <div class="display-1">
          Users
        </div>
        <v-breadcrumbs class="px-0 py-2"
                       :items="breadcrumbs">
        </v-breadcrumbs>
      </div>
      <v-spacer></v-spacer>
      <v-btn :to="{name: 'user.create'}"
             color="primary"
             :disabled="!team.has_seats_available">
        Create User
      </v-btn>
    </div>

    <v-alert class="mb-4"
             v-if="isAdmin"
             :type="team.has_seats_available ? 'success' : 'warning'">
      You are using {{ team.licensed_users }} out of {{ team.max_users | pluralize('seat') }}.
      <router-link :to="{name: 'subscription'}"
                   class="white--text">
        Add more seats.
      </router-link>
    </v-alert>

    <users-table :users="users"
                 :loading="loading"
                 @updated="fetchData">
    </users-table>

  </v-container>
</template>
<script>
import {mapGetters} from 'vuex';
import UsersTable from './components/UsersTable';
import {Form} from "vform";

export default {
  metaInfo() {
    this.$store.commit('setTitle', 'Users');
    return {
      title: this.$store.getters.title,
    }
  },
  components: {UsersTable},
  data() {
    return {
      breadcrumbs: [
        {text: 'Users', disabled: false, exact: true, to: {name: 'users'}},
        {text: 'List'}
      ],
      loading: false,
    }
  },
  computed: {
    ...mapGetters([
      'isAdmin',
      'team',
      'users',
    ]),
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      this.$store.dispatch('fetchGroups').then();
      await this.$store.dispatch('fetchUsers');
      this.loading = false;
    }
  }
}
</script>
